import { Dropdown } from '@geberit/gdds';

// types
import type { FilterProps } from './filter.types';

// utils
import { formatDistance } from 'utils/locator';
import { decodingContent } from 'utils/decodingContent';
import { useTracking } from 'utils/hooks/useTracking';
import { RADIUS_VALUES } from '../constants';
import { locatorEvent } from '../tracking-actions';

type DistanceFilterProps = {
  maxDistance: FilterProps['maxDistance'];
  setMaxDistance: (value: FilterProps['maxDistance']) => void;
  setIsSelectedDropdown: (value: boolean) => void;
  distanceLabel: string;
  unit?: string;
};

function DistanceFilter({
  maxDistance,
  setMaxDistance,
  unit = 'Radius',
  setIsSelectedDropdown,
  distanceLabel,
}: Readonly<DistanceFilterProps>) {
  const track = useTracking();
  const decodedDistanceLabel = decodingContent(distanceLabel);

  const handleFilterClick = (option) => {
    const label = option && formatDistance(option, unit, true);
    setMaxDistance(option || 'none');
    setIsSelectedDropdown(!!option || false);
    track.trackEvent(locatorEvent('Locator-Search', label || decodedDistanceLabel));
  };

  const options = RADIUS_VALUES.map((option) => ({
    id: formatDistance(option, unit, true),
    value: formatDistance(option, unit, true) * 1000,
    text: formatDistance(option, unit, true),
  }));
  options.unshift({ id: 'resetDistance', text: decodedDistanceLabel, value: undefined });
  return (
    <Dropdown
      placeholder={
        maxDistance === 'none' ? decodedDistanceLabel : (formatDistance(maxDistance, unit, true) ?? '')
      }
      name="distance"
      outlined
      items={options}
      onChange={(option) => {
        handleFilterClick(option?.value);
      }}
      defaultValue={maxDistance || formatDistance(RADIUS_VALUES[0].value, unit, true) * 1000}
      forceCustom
    />
  );
}

export default DistanceFilter;
